var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobSeekers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_2_Background_Mask_",
    "data-name": "Frame 2 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(5.087 0.515) rotate(15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_3_Background_Mask_",
    "data-name": "Frame 3 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.924, 0.383, -0.383, 0.924, 7.536, 1.265)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_4_Background_Mask_",
    "data-name": "Frame 4 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 9.867, 2.329)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_5_Background_Mask_",
    "data-name": "Frame 5 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.793, 0.609, -0.609, 0.793, 12.039, 3.688)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_6_Background_Mask_",
    "data-name": "Frame 6 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(14.014 5.318) rotate(45)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_7_Background_Mask_",
    "data-name": "Frame 7 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.609, 0.793, -0.793, 0.609, 15.761, 7.193)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_8_Background_Mask_",
    "data-name": "Frame 8 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(17.247 9.279) rotate(60)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_9_Background_Mask_",
    "data-name": "Frame 9 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(18.449 11.542) rotate(67.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_10_Background_Mask_",
    "data-name": "Frame 10 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 19.344, 13.942)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_11_Background_Mask_",
    "data-name": "Frame 11 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.131, 0.991, -0.991, 0.131, 19.919, 16.439)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_12_Background_Mask_",
    "data-name": "Frame 12 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(20.163 18.989) rotate(90)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_13_Background_Mask_",
    "data-name": "Frame 13 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.131, 0.991, -0.991, -0.131, 20.073, 21.549)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_14_Background_Mask_",
    "data-name": "Frame 14 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(19.648 24.076) rotate(105)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_15_Background_Mask_",
    "data-name": "Frame 15 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(18.898 26.525) rotate(112.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_16_Background_Mask_",
    "data-name": "Frame 16 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.5, 0.866, -0.866, -0.5, 17.834, 28.856)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_17_Background_Mask_",
    "data-name": "Frame 17 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(16.476 31.027) rotate(127.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_18_Background_Mask_",
    "data-name": "Frame 18 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(14.845 33.003) rotate(135)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_19_Background_Mask_",
    "data-name": "Frame 19 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(12.97 34.749) rotate(142.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_20_Background_Mask_",
    "data-name": "Frame 20 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(10.884 36.236) rotate(150)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_21_Background_Mask_",
    "data-name": "Frame 21 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(8.621 37.437) rotate(157.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_22_Background_Mask_",
    "data-name": "Frame 22 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 6.221, 38.333)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_23_Background_Mask_",
    "data-name": "Frame 23 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(3.725 38.908) rotate(172.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_24_Background_Mask_",
    "data-name": "Frame 24 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(1.175 39.152) rotate(-180)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_25_Background_Mask_",
    "data-name": "Frame 25 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-1.386 39.062) rotate(-172.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_26_Background_Mask_",
    "data-name": "Frame 26 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-3.912 38.637) rotate(-165)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_27_Background_Mask_",
    "data-name": "Frame 27 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.924, -0.383, 0.383, -0.924, -6.362, 37.887)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_28_Background_Mask_",
    "data-name": "Frame 28 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.866, -0.5, 0.5, -0.866, -8.692, 36.823)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_29_Background_Mask_",
    "data-name": "Frame 29 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-10.864 35.465) rotate(-142.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_30_Background_Mask_",
    "data-name": "Frame 30 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-12.84 33.834) rotate(-135)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_31_Background_Mask_",
    "data-name": "Frame 31 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.609, -0.793, 0.793, -0.609, -14.586, 31.959)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_32_Background_Mask_",
    "data-name": "Frame 32 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-16.073 29.873) rotate(-120)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_33_Background_Mask_",
    "data-name": "Frame 33 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-17.274 27.61) rotate(-112.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_34_Background_Mask_",
    "data-name": "Frame 34 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.17 25.21) rotate(-105)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_35_Background_Mask_",
    "data-name": "Frame 35 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.745 22.714) rotate(-97.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_36_Background_Mask_",
    "data-name": "Frame 36 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.989 20.163) rotate(-90)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_37_Background_Mask_",
    "data-name": "Frame 37 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.131, -0.991, 0.991, 0.131, -18.898, 17.603)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_38_Background_Mask_",
    "data-name": "Frame 38 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.474 15.077) rotate(-75)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_39_Background_Mask_",
    "data-name": "Frame 39 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-17.723 12.627) rotate(-67.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_40_Background_Mask_",
    "data-name": "Frame 40 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-16.66 10.297) rotate(-60)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_41_Background_Mask_",
    "data-name": "Frame 41 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.609, -0.793, 0.793, 0.609, -15.301, 8.125)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_42_Background_Mask_",
    "data-name": "Frame 42 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-13.67 6.149) rotate(-45)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_43_Background_Mask_",
    "data-name": "Frame 43 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-11.796 4.403) rotate(-37.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_44_Background_Mask_",
    "data-name": "Frame 44 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -9.709, 2.916)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_45_Background_Mask_",
    "data-name": "Frame 45 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-7.447 1.715) rotate(-22.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_46_Background_Mask_",
    "data-name": "Frame 46 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -5.047, 0.819)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_47_Background_Mask_",
    "data-name": "Frame 47 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-2.55 0.244) rotate(-7.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_48_Background_Mask_",
    "data-name": "Frame 48 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1_Background_Mask_",
    "data-name": "Frame 1 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(2.56 0.091) rotate(7.5)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14071",
    "data-name": "Group 14071",
    transform: "translate(-1055 -2429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13806",
    "data-name": "Group 13806",
    transform: "translate(-116 1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1171 1309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon_Background_",
    "data-name": "icon (Background)",
    width: 159,
    height: 159,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "container",
    d: "M159,0V159H0V0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(14.758 15.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    d: "M64.323,128.645a64.323,64.323,0,1,1,64.323-64.323A64.323,64.323,0,0,1,64.323,128.645Z",
    fill: "#f0f9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Burst",
    transform: "translate(93.222 85.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_2",
    "data-name": "Frame 2",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_2_Background_Mask_2",
    "data-name": "Frame 2 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(5.087 0.515) rotate(15)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_2-2",
    "data-name": "Frame 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(7.018 1.033) rotate(15)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_3",
    "data-name": "Frame 3",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_3_Background_Mask_2",
    "data-name": "Frame 3 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.924, 0.383, -0.383, 0.924, 7.536, 1.265)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_3-2",
    "data-name": "Frame 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_2",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.924, 0.383, -0.383, 0.924, 9.384, 2.031)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_4",
    "data-name": "Frame 4",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_4_Background_Mask_2",
    "data-name": "Frame 4 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 9.867, 2.329)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_4-2",
    "data-name": "Frame 4",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_3",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 11.599, 3.329)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_5",
    "data-name": "Frame 5",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_5_Background_Mask_2",
    "data-name": "Frame 5 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.793, 0.609, -0.609, 0.793, 12.039, 3.688)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_5-2",
    "data-name": "Frame 5",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_4",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.793, 0.609, -0.609, 0.793, 13.626, 4.905)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_6",
    "data-name": "Frame 6",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_6_Background_Mask_2",
    "data-name": "Frame 6 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(14.014 5.318) rotate(45)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_6-2",
    "data-name": "Frame 6",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_5",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(15.429 6.733) rotate(45)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_7",
    "data-name": "Frame 7",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_7_Background_Mask_2",
    "data-name": "Frame 7 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.609, 0.793, -0.793, 0.609, 15.761, 7.193)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_7-2",
    "data-name": "Frame 7",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_6",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.609, 0.793, -0.793, 0.609, 16.978, 8.78)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_8",
    "data-name": "Frame 8",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_8_Background_Mask_2",
    "data-name": "Frame 8 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(17.247 9.279) rotate(60)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_8-2",
    "data-name": "Frame 8",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_7",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(18.247 11.012) rotate(60)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_9",
    "data-name": "Frame 9",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_9_Background_Mask_2",
    "data-name": "Frame 9 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(18.449 11.542) rotate(67.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_9-2",
    "data-name": "Frame 9",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_8",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(19.214 13.39) rotate(67.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_10",
    "data-name": "Frame 10",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_10_Background_Mask_2",
    "data-name": "Frame 10 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 19.344, 13.942)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_10-2",
    "data-name": "Frame 10",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_9",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 19.862, 15.874)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_11",
    "data-name": "Frame 11",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_11_Background_Mask_2",
    "data-name": "Frame 11 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.131, 0.991, -0.991, 0.131, 19.919, 16.439)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_11-2",
    "data-name": "Frame 11",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_10",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.131, 0.991, -0.991, 0.131, 20.181, 18.422)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_12",
    "data-name": "Frame 12",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_12_Background_Mask_2",
    "data-name": "Frame 12 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(20.163 18.989) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_12-2",
    "data-name": "Frame 12",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_11",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(20.163 20.989) rotate(90)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_13",
    "data-name": "Frame 13",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_13_Background_Mask_2",
    "data-name": "Frame 13 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.131, 0.991, -0.991, -0.131, 20.073, 21.549)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_13-2",
    "data-name": "Frame 13",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_12",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(-0.131, 0.991, -0.991, -0.131, 19.811, 23.532)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_14",
    "data-name": "Frame 14",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_14_Background_Mask_2",
    "data-name": "Frame 14 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(19.648 24.076) rotate(105)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_14-2",
    "data-name": "Frame 14",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_13",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(19.131 26.007) rotate(105)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_15",
    "data-name": "Frame 15",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_15_Background_Mask_2",
    "data-name": "Frame 15 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(18.898 26.525) rotate(112.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_15-2",
    "data-name": "Frame 15",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_14",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(18.133 28.373) rotate(112.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_16",
    "data-name": "Frame 16",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_16_Background_Mask_2",
    "data-name": "Frame 16 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.5, 0.866, -0.866, -0.5, 17.834, 28.856)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_16-2",
    "data-name": "Frame 16",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_15",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(-0.5, 0.866, -0.866, -0.5, 16.834, 30.588)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_17",
    "data-name": "Frame 17",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_17_Background_Mask_2",
    "data-name": "Frame 17 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(16.476 31.027) rotate(127.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_17-2",
    "data-name": "Frame 17",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_16",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(15.258 32.614) rotate(127.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_18",
    "data-name": "Frame 18",
    transform: "translate(18.988 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_18_Background_Mask_2",
    "data-name": "Frame 18 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(14.845 33.003) rotate(135)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_18-2",
    "data-name": "Frame 18",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_17",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(13.431 34.418) rotate(135)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_19",
    "data-name": "Frame 19",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_19_Background_Mask_2",
    "data-name": "Frame 19 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(12.97 34.749) rotate(142.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_19-2",
    "data-name": "Frame 19",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_18",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(11.383 35.967) rotate(142.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_20",
    "data-name": "Frame 20",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_20_Background_Mask_2",
    "data-name": "Frame 20 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(10.884 36.236) rotate(150)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_20-2",
    "data-name": "Frame 20",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_19",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(9.152 37.236) rotate(150)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_21",
    "data-name": "Frame 21",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_21_Background_Mask_2",
    "data-name": "Frame 21 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(8.621 37.437) rotate(157.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_21-2",
    "data-name": "Frame 21",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_20",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(6.774 38.203) rotate(157.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_22",
    "data-name": "Frame 22",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_22_Background_Mask_2",
    "data-name": "Frame 22 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 6.221, 38.333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_22-2",
    "data-name": "Frame 22",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_21",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 4.29, 38.851)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_23",
    "data-name": "Frame 23",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_23_Background_Mask_2",
    "data-name": "Frame 23 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(3.725 38.908) rotate(172.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_23-2",
    "data-name": "Frame 23",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_22",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(1.742 39.169) rotate(172.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_24",
    "data-name": "Frame 24",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_24_Background_Mask_2",
    "data-name": "Frame 24 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(1.175 39.152) rotate(-180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_24-2",
    "data-name": "Frame 24",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_23",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-0.825 39.152) rotate(-180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_25",
    "data-name": "Frame 25",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_25_Background_Mask_2",
    "data-name": "Frame 25 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-1.386 39.062) rotate(-172.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_25-2",
    "data-name": "Frame 25",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_24",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-3.369 38.801) rotate(-172.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_26",
    "data-name": "Frame 26",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_26_Background_Mask_2",
    "data-name": "Frame 26 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-3.912 38.637) rotate(-165)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_26-2",
    "data-name": "Frame 26",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_25",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-5.844 38.12) rotate(-165)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_27",
    "data-name": "Frame 27",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_27_Background_Mask_2",
    "data-name": "Frame 27 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.924, -0.383, 0.383, -0.924, -6.362, 37.887)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_27-2",
    "data-name": "Frame 27",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_26",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(-0.924, -0.383, 0.383, -0.924, -8.209, 37.122)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_28",
    "data-name": "Frame 28",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_28_Background_Mask_2",
    "data-name": "Frame 28 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.866, -0.5, 0.5, -0.866, -8.692, 36.823)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_28-2",
    "data-name": "Frame 28",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_27",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(-0.866, -0.5, 0.5, -0.866, -10.424, 35.823)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_29",
    "data-name": "Frame 29",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_29_Background_Mask_2",
    "data-name": "Frame 29 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-10.864 35.465) rotate(-142.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_29-2",
    "data-name": "Frame 29",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_28",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-12.451 34.247) rotate(-142.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_30",
    "data-name": "Frame 30",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_30_Background_Mask_2",
    "data-name": "Frame 30 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-12.84 33.834) rotate(-135)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_30-2",
    "data-name": "Frame 30",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_29",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-14.254 32.42) rotate(-135)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_31",
    "data-name": "Frame 31",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_31_Background_Mask_2",
    "data-name": "Frame 31 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(-0.609, -0.793, 0.793, -0.609, -14.586, 31.959)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_31-2",
    "data-name": "Frame 31",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_30",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(-0.609, -0.793, 0.793, -0.609, -15.803, 30.373)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_32",
    "data-name": "Frame 32",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_32_Background_Mask_2",
    "data-name": "Frame 32 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-16.073 29.873) rotate(-120)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_32-2",
    "data-name": "Frame 32",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_31",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-17.073 28.141) rotate(-120)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_33",
    "data-name": "Frame 33",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_33_Background_Mask_2",
    "data-name": "Frame 33 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-17.274 27.61) rotate(-112.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_33-2",
    "data-name": "Frame 33",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_32",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-18.039 25.762) rotate(-112.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_34",
    "data-name": "Frame 34",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_34_Background_Mask_2",
    "data-name": "Frame 34 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.17 25.21) rotate(-105)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_34-2",
    "data-name": "Frame 34",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_33",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-18.687 23.278) rotate(-105)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_35",
    "data-name": "Frame 35",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_35_Background_Mask_2",
    "data-name": "Frame 35 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.745 22.714) rotate(-97.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_35-2",
    "data-name": "Frame 35",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_34",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-19.006 20.731) rotate(-97.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_36",
    "data-name": "Frame 36",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_36_Background_Mask_2",
    "data-name": "Frame 36 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.989 20.163) rotate(-90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_36-2",
    "data-name": "Frame 36",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_35",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-18.989 18.163) rotate(-90)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_37",
    "data-name": "Frame 37",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_37_Background_Mask_2",
    "data-name": "Frame 37 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.131, -0.991, 0.991, 0.131, -18.898, 17.603)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_37-2",
    "data-name": "Frame 37",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_36",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.131, -0.991, 0.991, 0.131, -18.637, 15.62)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_38",
    "data-name": "Frame 38",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_38_Background_Mask_2",
    "data-name": "Frame 38 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-18.474 15.077) rotate(-75)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_38-2",
    "data-name": "Frame 38",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_37",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-17.956 13.145) rotate(-75)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_39",
    "data-name": "Frame 39",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_39_Background_Mask_2",
    "data-name": "Frame 39 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-17.723 12.627) rotate(-67.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_39-2",
    "data-name": "Frame 39",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_38",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-16.958 10.78) rotate(-67.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_40",
    "data-name": "Frame 40",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_40_Background_Mask_2",
    "data-name": "Frame 40 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-16.66 10.297) rotate(-60)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_40-2",
    "data-name": "Frame 40",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_39",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-15.66 8.565) rotate(-60)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_41",
    "data-name": "Frame 41",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_41_Background_Mask_2",
    "data-name": "Frame 41 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.609, -0.793, 0.793, 0.609, -15.301, 8.125)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_41-2",
    "data-name": "Frame 41",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_40",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.609, -0.793, 0.793, 0.609, -14.084, 6.538)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_42",
    "data-name": "Frame 42",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_42_Background_Mask_2",
    "data-name": "Frame 42 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-13.67 6.149) rotate(-45)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_42-2",
    "data-name": "Frame 42",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_41",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-12.256 4.735) rotate(-45)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_43",
    "data-name": "Frame 43",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_43_Background_Mask_2",
    "data-name": "Frame 43 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-11.796 4.403) rotate(-37.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_43-2",
    "data-name": "Frame 43",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_42",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-10.209 3.185) rotate(-37.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_44",
    "data-name": "Frame 44",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_44_Background_Mask_2",
    "data-name": "Frame 44 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -9.709, 2.916)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_44-2",
    "data-name": "Frame 44",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_43",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -7.977, 1.916)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_45",
    "data-name": "Frame 45",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_45_Background_Mask_2",
    "data-name": "Frame 45 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-7.447 1.715) rotate(-22.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_45-2",
    "data-name": "Frame 45",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_44",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-5.599 0.95) rotate(-22.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_46",
    "data-name": "Frame 46",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_46_Background_Mask_2",
    "data-name": "Frame 46 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -5.047, 0.819)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_46-2",
    "data-name": "Frame 46",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_45",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -3.115, 0.301)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_47",
    "data-name": "Frame 47",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_47_Background_Mask_2",
    "data-name": "Frame 47 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(-2.55 0.244) rotate(-7.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_47-2",
    "data-name": "Frame 47",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_46",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(-0.567 -0.017) rotate(-7.5)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_48",
    "data-name": "Frame 48",
    transform: "translate(18.989)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_48_Background_Mask_2",
    "data-name": "Frame 48 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_48-2",
    "data-name": "Frame 48",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_47",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(2)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_1",
    "data-name": "Frame 1",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1_Background_Mask_2",
    "data-name": "Frame 1 (Background/Mask)",
    width: 1.175,
    height: 39.152,
    transform: "translate(2.56 0.091) rotate(7.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_1-2",
    "data-name": "Frame 1",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84_Stroke_48",
    "data-name": "Vector 84 (Stroke)",
    d: "M0,0H2V92H0Z",
    transform: "translate(4.543 0.352) rotate(7.5)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Burst-pucker-2",
    d: "M12.176,11.511c-1.592,1.242-1.969,3.516-2.388,8.065-.433-4.716-.824-6.977-2.569-8.191C5.865,10.437,3.672,10.13,0,9.8c3.826-.349,6.046-.67,7.387-1.716C8.992,6.823,9.369,4.563,9.788,0c.391,4.2.74,6.446,2.039,7.744s3.561,1.66,7.75,2.037C15.737,10.13,13.53,10.451,12.176,11.511Z",
    transform: "translate(7.646 11.202)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_7_Stroke_",
    "data-name": "Ellipse 7 (Stroke)",
    d: "M3.5,6.991a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,3.5,6.991Zm0-5.546A2.05,2.05,0,1,0,5.546,3.5,2.053,2.053,0,0,0,3.5,1.445Z",
    transform: "translate(116.055 27.102)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_9_Stroke_",
    "data-name": "Ellipse 9 (Stroke)",
    d: "M2.168,4.336A2.168,2.168,0,1,1,4.336,2.168,2.171,2.171,0,0,1,2.168,4.336Zm0-2.891a.723.723,0,1,0,.723.723A.724.724,0,0,0,2.168,1.445Z",
    transform: "translate(31.857 3.975)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8_Stroke_",
    "data-name": "Ellipse 8 (Stroke)",
    d: "M5.36,10.721a5.36,5.36,0,1,1,5.36-5.36A5.366,5.366,0,0,1,5.36,10.721Zm0-9.275A3.915,3.915,0,1,0,9.275,5.36,3.919,3.919,0,0,0,5.36,1.445Z",
    transform: "translate(16.313 111.4)",
    fill: "#136ad0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(1104.842 2482.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14070",
    "data-name": "Group 14070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M35,5.912h0a20.185,20.185,0,0,1,0,28.546h0A20.185,20.185,0,1,1,6.457,5.912h0A20.185,20.185,0,0,1,35,5.912h0ZM33.038,7.878h0a17.406,17.406,0,0,0-24.614,0h0A17.405,17.405,0,0,0,33.038,32.493h0a17.406,17.406,0,0,0,0-24.614Z",
    transform: "translate(18.4)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    d: "M9.7,3.3A1.39,1.39,0,0,0,7.732,1.33L.914,8.148A1.39,1.39,0,1,0,2.88,10.113Z",
    transform: "translate(17.126 31.162)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M17.585,1.856l4.852,4.852h0a2.762,2.762,0,0,1,0,3.9l-.983-.978.983.983-.01.01L9.58,23.475a2.762,2.762,0,0,1-3.907,0l0,0h0l-.01-.01L.808,18.613h0a1.391,1.391,0,0,1-.1-.112,2.761,2.761,0,0,1,.1-3.8L13.666,1.846h0a2.762,2.762,0,0,1,3.9,0l-.978.983.983-.983.01.01ZM20.46,8.663l-4.84-4.84L2.785,16.658l4.84,4.84ZM7.627,21.522l0,0h0v0Zm0,0,0,0,.008-.008,0,0Zm-.972.972.972-.967v0Z",
    transform: "translate(0 35.033)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M6.852.171A5.9,5.9,0,1,1,2.683,1.9,5.879,5.879,0,0,1,6.852.171Zm2.2,3.693a3.116,3.116,0,1,0,.912,2.2A3.106,3.106,0,0,0,9.056,3.864Z",
    transform: "translate(32.278 5.775)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M6.978.574H16.39a6.179,6.179,0,0,1,6.165,6.165v4.775a1.39,1.39,0,0,1-1.39,1.39H2.2a1.39,1.39,0,0,1-1.39-1.39V6.739A6.179,6.179,0,0,1,6.978.574Zm9.411,2.78H6.978A3.4,3.4,0,0,0,3.594,6.739v3.385H19.774V6.739A3.4,3.4,0,0,0,16.39,3.354Z",
    transform: "translate(27.447 19.365)",
    fill: "#136ad0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSeekers);
export default __webpack_public_path__ + "static/media/job-seekers.10ef705596e8b5d93c1c022f1a40144c.svg";
export { ForwardRef as ReactComponent };